module.exports = __webpack_public_path__ + "img/sample-error-4.e372dd2.webp";